import { CountryCode } from "pages/employer-of-record/onboarding/constants";
import * as CA_CONFIGS from "./countryConfigs/CA/constants";
import * as GB_CONFIGS from "./countryConfigs/GB/constants";
import * as MX_CONFIGS from "./countryConfigs/MX/constants";
import * as ES_CONFIGS from "./countryConfigs/ES/constants";
import * as NL_CONFIGS from "./countryConfigs/NL/constants";
import * as PT_CONFIGS from "./countryConfigs/PT/constants";
import * as CO_CONFIGS from "./countryConfigs/CO/constants";
import * as IE_CONFIGS from "./countryConfigs/IE/constants";
import * as IL_CONFIGS from "./countryConfigs/IL/constants";
import * as IN_CONFIGS from "./countryConfigs/IN/constants";
import * as IT_CONFIGS from "./countryConfigs/IT/constants";
import * as AU_CONFIGS from "./countryConfigs/AU/constants";
import * as BR_CONFIGS from "./countryConfigs/BR/constants";
import * as PH_CONFIGS from "./countryConfigs/PH/constants";
import * as SG_CONFIGS from "./countryConfigs/SG/constants";
import * as MY_CONFIGS from "./countryConfigs/MY/constants";
import * as CL_CONFIGS from "./countryConfigs/CL/constants";
import * as CR_CONFIGS from "./countryConfigs/CR/constants";
import * as DK_CONFIGS from "./countryConfigs/DK/constants";
import * as SE_CONFIGS from "./countryConfigs/SE/constants";
import * as EE_CONFIGS from "./countryConfigs/EE/constants";
import * as PE_CONFIGS from "./countryConfigs/PE/constants";
import * as GR_CONFIGS from "./countryConfigs/GR/constants";
import * as TR_CONFIGS from "./countryConfigs/TR/constants";
import * as ZA_CONFIGS from "./countryConfigs/ZA/constants";
import * as PL_CONFIGS from "./countryConfigs/PL/constants";
import * as RO_CONFIGS from "./countryConfigs/RO/constants";
import * as DE_CONFIGS from "./countryConfigs/DE/constants";
import * as FR_CONFIGS from "./countryConfigs/FR/constants";

import { CountryConfigKeyType } from "./types";

const CONFIG_MAPS = {
  [CountryCode.CA]: CA_CONFIGS,
  [CountryCode.DK]: DK_CONFIGS,
  [CountryCode.GB]: GB_CONFIGS,
  [CountryCode.MX]: MX_CONFIGS,
  [CountryCode.ES]: ES_CONFIGS,
  [CountryCode.NL]: NL_CONFIGS,
  [CountryCode.PT]: PT_CONFIGS,
  [CountryCode.CO]: CO_CONFIGS,
  [CountryCode.IE]: IE_CONFIGS,
  [CountryCode.IL]: IL_CONFIGS,
  [CountryCode.IN]: IN_CONFIGS,
  [CountryCode.IT]: IT_CONFIGS,
  [CountryCode.AU]: AU_CONFIGS,
  [CountryCode.BR]: BR_CONFIGS,
  [CountryCode.PE]: PE_CONFIGS,
  [CountryCode.PH]: PH_CONFIGS,
  [CountryCode.SG]: SG_CONFIGS,
  [CountryCode.MY]: MY_CONFIGS,
  [CountryCode.CL]: CL_CONFIGS,
  [CountryCode.CR]: CR_CONFIGS,
  [CountryCode.SE]: SE_CONFIGS,
  [CountryCode.EE]: EE_CONFIGS,
  [CountryCode.GR]: GR_CONFIGS,
  [CountryCode.TR]: TR_CONFIGS,
  [CountryCode.ZA]: ZA_CONFIGS,
  [CountryCode.PL]: PL_CONFIGS,
  [CountryCode.RO]: RO_CONFIGS,
  [CountryCode.DE]: DE_CONFIGS,
  [CountryCode.FR]: FR_CONFIGS,
};

export const loadCountryConfigFiles = (country: CountryConfigKeyType) => {
  const configs = CONFIG_MAPS[country];
  return configs;
};
